/* eslint-disable import/prefer-default-export */
/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, February 2021
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

export function emailReceipt(payload: any) {
  return {
    type: ActionTypes.EMAIL_RECEIPT_REQUEST,
    payload: { ...payload },
  };
}

export function smsReceipt(payload: any) {
  return {
    type: ActionTypes.SMS_RECEIPT_REQUEST,
    payload: { ...payload },
  };
}

export function printReceipt(payload: any) {
  return {
    type: ActionTypes.PRINT_RECEIPT_REQUEST,
    payload: { ...payload },
  };
}
